import albieLogo from '@/assets/img/albie-logo-primary.svg'
import notFoundSVG from '@/assets/img/not_found.svg'
import { FormattedMessage } from 'react-intl'
import { Link } from '@tanstack/react-router'
import { BUTTON_VARIANTS, cn } from '../lib/utils'

export function NotFoundRoot() {
  return (
    <div className='relative grid h-dvh w-full grid-rows-[80px,auto]'>
      <div className='w-full py-5 pl-6 md:pl-24'>
        <div>
          <img src={albieLogo} alt='Albie logo' />
        </div>
      </div>
      <div className='mt-[8%] flex flex-col gap-3 px-4'>
        <div className='mx-auto'>
          <img src={notFoundSVG} alt='' />
        </div>
        <h1 className='text-center font-bold'>
          <FormattedMessage id='common.pageNotFound' />
        </h1>
        <p className='text-center'>
          <FormattedMessage id='common.pageNotFoundDescription' />
        </p>
        <Link
          to='/'
          className={cn(
            BUTTON_VARIANTS({ variant: 'accent' }),
            'mx-auto w-fit'
          )}
        >
          <FormattedMessage id='common.signIn' />
        </Link>
      </div>
      <div className='absolute left-[35%] top-[10%] h-12 w-12 rounded-full bg-accent'></div>
      <div className='absolute left-[15%] top-[55%] h-12 w-12 rounded-full bg-primary'></div>
      <div className='absolute left-[65%] top-[75%] h-12 w-12 rounded-full bg-secondary'></div>
    </div>
  )
}
